export const findMissingUtil  = (first, second) => {
    const spreaded = [...first, ...second];
    return spreaded.filter(el => {
       return !(first.includes(el) && second.includes(el));
    })
 };
